import { Link, Skeleton, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { Link as RouterLink } from 'react-router';
import type { Voordracht } from '../api/typen.ts';
import { useVoordrachtDetails } from '../api/voordrachten.ts';
import { datumTijd, volledigeNaam } from '../helpers/formatteer.ts';
import { StatusChip } from './StatusChip.tsx';

interface Props {
  voordrachten: readonly Voordracht[];
  toon: 'kandidaat' | 'vacature' | 'beide';
}

/**
 * Een tabel met voordrachten. De lijstroutes geven alleen id's, dus kandidaat en vacature worden per voordracht
 * opgehaald.
 * @param props De voordrachten en welke kolommen getoond worden.
 * @returns De tabel.
 */
export function VoordrachtenTabel({ voordrachten, toon }: Props) {
  const { details } = useVoordrachtDetails(voordrachten);
  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          {toon !== 'vacature' && <TableCell>Kandidaat</TableCell>}
          {toon !== 'kandidaat' && <TableCell>Vacature</TableCell>}
          <TableCell>Fase</TableCell>
          <TableCell>Uitkomst</TableCell>
          <TableCell>Gewijzigd</TableCell>
          <TableCell />
        </TableRow>
      </TableHead>
      <TableBody>
        {voordrachten.map((voordracht, index) => {
          const detail = details[index];
          return (
            <TableRow key={voordracht.id} hover>
              {toon !== 'vacature' && (
                <TableCell>
                  {detail ? (
                    <Link component={RouterLink} to={`/kandidaten/${voordracht.kandidaatId}`} underline="hover">
                      {volledigeNaam(detail.kandidaat)}
                    </Link>
                  ) : (
                    <Skeleton width={140} />
                  )}
                </TableCell>
              )}
              {toon !== 'kandidaat' && (
                <TableCell>
                  {detail ? (
                    <Link component={RouterLink} to={`/vacatures/${voordracht.vacatureId}`} underline="hover">
                      {detail.vacature.titel}
                    </Link>
                  ) : (
                    <Skeleton width={160} />
                  )}
                </TableCell>
              )}
              <TableCell>
                <StatusChip soort="fase" waarde={voordracht.fase} />
              </TableCell>
              <TableCell>
                <StatusChip soort="uitkomst" waarde={voordracht.uitkomst} />
              </TableCell>
              <TableCell>{datumTijd(voordracht.gewijzigdOp)}</TableCell>
              <TableCell align="right">
                <Link component={RouterLink} to={`/voordrachten/${voordracht.id}`} underline="hover">
                  Openen
                </Link>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}
